var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 6.192c.296 0 .555.059.776.176.221.117.392.283.512.496.123.21.184.455.184.732 0 .275-.061.519-.184.732-.12.213-.292.379-.516.496A1.624 1.624 0 015.3 9H4.248V6.192H5.3zm-.044 2.216c.259 0 .46-.07.604-.212.144-.141.216-.341.216-.6 0-.259-.072-.46-.216-.604-.144-.144-.345-.216-.604-.216h-.324v1.632h.324zm4.098-2.216v.548H8.21v.592h.856v.532H8.21V9h-.684V6.192h1.828zm2.87.904a.915.915 0 01-.111.448.828.828 0 01-.344.324 1.211 1.211 0 01-.576.124h-.424V9h-.684V6.192h1.108c.224 0 .413.039.568.116.154.077.27.184.348.32a.93.93 0 01.116.468zm-1.083.352c.13 0 .228-.03.292-.092a.343.343 0 00.096-.26.343.343 0 00-.096-.26c-.064-.061-.162-.092-.292-.092h-.372v.704h.372z",
    fill: "#fff"
  })));
}
export default SvgDfp;